(function() {
	/*
	 * SUG Advanced Breadcrumb
	 * Requires the following libs:
	 * - ui-bootstrap for dropdown menu
	 * - fitEllipsis for truncating long crumb titles
     *
     * Usage: <sug-advanced-breadcrumb data-ng-model="breadcrumb" header-class="headerClass"></sug-advanced-breadcrumb>
     * where "breadcrumb" is a compatible array of breadcrumbs and "headerClass" is a class assigned to the first crumb.
	 */
	SUGApp.directive('sugAdvancedBreadcrumb', ['$timeout', function ($timeout) {
		return {
			restrict: 'E',
			templateUrl: '/view/templates/ngtemplates/sug-advanced-breadcrumb.html',
			require: '?ngModel',
			scope: {
				parentModel: '=ngModel'
			},
			link: function(scope, element, attrs, ngModelCtrl) {
				if(!ngModelCtrl){ //do nothing if no model present
					return;
				}
				// popover config
				scope.pop = {
					trig: 'mouseenter',
					placement: 'top',
					delay: 300
				};
				scope.canMiddleFit = false;
				scope.crumbsArray = [];

				// this runs first
				function init(){
					// buffer of 20 px;
					scope.widthModifier = 20;
					scope.headerClass = angular.isDefined(attrs.headerClass) ? attrs.headerClass : 'h2';
					// this executes anytime the model value changes
					ngModelCtrl.$render = updateComponents;
					updateComponents();
				}

				/**
				 * Returns the width of the given element
				 * @param {Object} el - html element 
				 */
				function getElementWidth(el){
					var ele = angular.element(el);
					return ele.width();
				}

				/**
				 * Gets the total width of the breadcrumb containing element
				 */
				function getTotalWidth(){
					// accounts for a little buffer
					return getElementWidth(element.context.lastElementChild)-scope.widthModifier;
				}

				/**
				 * Update individual components of the directive using the model's value
				 */
				function updateComponents(){
					if( angular.isArray(ngModelCtrl.$viewValue) ){
						scope.crumbsArray = ngModelCtrl.$viewValue;
					}else{
						scope.crumbsArray = [];
					}
				}

				/**
				 * Calulates the remaining width of the breadcrumb element.
				 * @param {Integer} crumbIdx - index of the crumb in scope.crumbsArray
				 */
				scope.calculateWidth = function(crumbIdx){
					var currentWidth = 0;
					if( crumbIdx != 0 ){
						var startIdx = scope.blnBreakAfterRoot() ? 1 : 0;
						for(var i=startIdx; i<crumbIdx; i++){
							currentWidth += getElementWidth(element.context.lastElementChild.children[i]);
						}
					}	
					return getTotalWidth() - currentWidth;
				};

				/**
				 * Determines if there should be a line break after the crumb root
				 */
				scope.blnBreakAfterRoot = function(){					
					var totalWidth = getTotalWidth();
					var rootWidth = 1;
					if( element.context.lastElementChild.children[0] ){
						rootWidth = getElementWidth(element.context.lastElementChild.children[0]);			
					}

					if( scope.crumbsArray.length > 2 && element.context.lastElementChild.children[1] ){
						rootWidth += getElementWidth(element.context.lastElementChild.children[1]);
					}
					var rootPercent = rootWidth / totalWidth;
					return rootPercent > 0.60;
				};

				/*
				 * Since we are using an isolate scope for reusabilty and to support the use mulitple instances of this directive in one controller,
				 * we need this dual watch approach to keep our ngModels in sync.
				 */
				scope.$watchCollection('parentModel', function() {
					scope.$eval(attrs.ngModel + ' = parentModel');
				});

				scope.$watchCollection(attrs.ngModel, function(val) {
					scope.parentModel = val;
				});

				/**
				 * Watch for changes in the font size of the crumb root and trigger a width change to recalculate truncation
				 */
				scope.$watch( 
					function(){
						var crumbRoot = document.getElementsByClassName(scope.headerClass);
						if( crumbRoot && crumbRoot.length ){
							var crumbRootEl = angular.element(crumbRoot[0]);
							return crumbRootEl.css("font-size");
						}else{
							return 0;
						}
			   		}, 
					function(nVal,oVal) {
						if( nVal !== oVal ){							
							scope.widthModifier++;
						}					
					}
				);	

				/**
				 * Watch for changes in the width of the crumb root element and trigger a width change to recalculate truncation
				 */
				scope.$watch( 
					function(){
						if( element.context.lastElementChild.children[0] ){
							return  getElementWidth(element.context.lastElementChild.children[0]);
						}else{
							return 0;
						}
			   		}, 
					function(nVal,oVal) {
						if( oVal != nVal ){
							scope.widthModifier++;
						}					
					}
				); 

			
				/*
				scope.$watch( function(){
					 	return element.context.lastElementChild.children[0] ? element.context.lastElementChild.children[0].offsetWidth : 1;
					}, 
					function(nVal,oVal) {
						if( nVal !== oVal ){
							console.log('watch fired');
							scope.blnBreakAfterRoot();
						}					
				});	*/			

				/**
				 * Responds to the click event by removing all the elements after the clicked index and updating the model's value accordingly.
				 * @param {Integer} crumbIdx - the index of the crumb clicked
				 */
				scope.crumbClicked = function(crumbIdx){
					if( typeof scope.crumbsArray[crumbIdx] !== 'undefined' && scope.crumbsArray.length > crumbIdx+1 ){
						scope.crumbsArray.length = crumbIdx+1;
						$timeout( function(){
							ngModelCtrl.$setViewValue(angular.copy(scope.crumbsArray));
							ngModelCtrl.$render = updateComponents;
							// we need this to keep our ngModels in sync (see comment above parentModel watcher)
							updateComponents();
						});
					}
				};

				init();
            }
        };
    }]);

}());
